import React, { useEffect, useState, useRef } from 'react';
import './blogs_busq.css'
import { useTranslation } from 'react-i18next';

import rel from '../../../assets/img/relo.png';
import ir from '../../../assets/img/ir_acti.png';
import regresa from '../../../assets/img/regresa.png';
import regresa2 from '../../../assets/img/ir_izq.png';
import lupa from '../../../assets/img/lupa.png';
import flec from '../../../assets/img/flech_abaj.png';
import liber from '../../../assets/img/liber.png';
import edu from '../../../assets/img/educ.png';
import arte from '../../../assets/img/arte.png';
import lider from '../../../assets/img/lider.png';
import inov from '../../../assets/img/inov.png';
import dere from '../../../assets/img/estad.png';
import prosp from '../../../assets/img/prosp.png';
import biblio from '../../../assets/img/bibli.png';
import medio from '../../../assets/img/medio.png';

const Blogs_busq = ({ contenido }) => {
    const [t2] = useTranslation("busqueda");
    const [t] = useTranslation("ideas_libertad");
    const formatDate = (date) => {
        const options = { day: "numeric", month: "long", year: "numeric" };
        return new Date(date).toLocaleDateString(undefined, options);
    };

    const numero = () => {
        const i = Math.floor(Math.random() * 5) + 1

        return i

    }

    if (!contenido || !contenido.blogNs || contenido.blogNs.length === 0) {
        // Handle the case where `contenido` or `blogNs` is not available or is an empty array.
        return <div></div>;
      }



    return (
        <div id='bus_blogs' className='blogs_busq'>
            <div className='titulo_div'>
                <p className='tit1'>{(t2('blogs.titulo1'))} <span className='tit2'>{(t2('blogs.titulo2'))}</span></p>
            </div>
            <div className="list_content--items">
                {

                    contenido.blogNs.map((item, index) => (
                        <div key={index} className="card">
                            <div className="front">
                                <img className="imgG_LB" src={item.urlImagen} alt={item.urlImagen} />
                                <div className="cinta">
                                    <p className="tit_LB">{item.titulo}</p>
                                </div>
                            </div>

                            <div className="back">
                                <p className="fh_LB"> {formatDate(item.fecha)}  </p>
                                <p className="catego">
                                    {
                                        item.categorias.map(dat => dat.nombre).join(' | ')
                                    }
                                </p>
                                <hr className="line_LB"></hr>
                                <p className="titu_LB">{item.titulo}
                                </p>
                                <p className="desc_LB">{item.resumen.substring(0, 115) + '...'}
                                </p>
                                <img className="reloj_LB " src={rel} alt="reloj"></img>
                                <p className="alineIzq_ub_LB"> {numero()} {(t('filtro.tiempo-lectura'))}</p>
                                <div className="div_bot_LB">

                                    <a className="buton_LB" target="_blank" href={"/blog/" + item.tag}>{(t('filtro.leer'))}</a>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>

    );

}

export default Blogs_busq;